/** Studio B's one motion for everything that moves (Ivy, the side panels, the rail, the dock): --b-move-ms on --b-ease. */
export const B_MOVE = { duration: 0.42, ease: [0.2, 0, 0, 1] as const };

/** A view swapping for another in place fades on the same curve, at --b-panel-ms. */
export const B_FADE = { duration: 0.18, ease: [0.2, 0, 0, 1] as const };

const STILL = { duration: 0 };
const reduced = () => !!globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export const bMove = () => (reduced() ? STILL : B_MOVE);
export const bFade = () => (reduced() ? STILL : B_FADE);
